var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loading",class:_vm.data?'goster':''},[_c('div',{staticClass:"lKutu"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text?_vm.text:'Yükleniyor')}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8e31d1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doc/Yukleniyor.vue
// module id = 636
// module chunks = 0